import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

// INTERFACES
import {
  CustomFieldApiService, SnackBarConfig, trackById
} from '../../../shared';
import {
  ICustomField,
  ECustomFieldType,
} from '../../interfaces/custom-field.interface';

@Component({
  selector: 'lum-custom-field-details',
  templateUrl: './custom-field-details.component.html',
  styleUrls: ['./custom-field-details.component.scss']
})
export class CustomFieldDetailsComponent implements OnInit, OnDestroy {
  customFieldId :number = 0;

  loading :boolean = false;

  customField :ICustomField;

  eCustomFieldType = ECustomFieldType;
  
  trackById = trackById;

  private onDestroy$ = new Subject();

  constructor(
    private customFieldApiService :CustomFieldApiService,
    private route :ActivatedRoute,
    private cd :ChangeDetectorRef,
    private snackBar :MatSnackBar,
  ) {}

  ngOnInit() :void {
    this.getRouterParams().subscribe();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  private loadCustomField(customFieldId :number) :void {
    this.loading = true;
    this.customFieldApiService
      .getById(customFieldId)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (response) => {
          this.loading = false;
          this.customField = response;
          this.cd.detectChanges();
        },
        error: (response) => {
          this.loading = false;
          this.snackBar.open(response.error, 'Fail', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
          this.cd.detectChanges();
        },
      });
  }

  private getRouterParams() :Observable<Params> {
    return this.route.params.pipe(
      tap((params :Params) => {
        const { customFieldId } = params;
        if (customFieldId) {
          this.customFieldId = customFieldId;
          this.loadCustomField(this.customFieldId);
        }
      }),
      takeUntil(this.onDestroy$),
    );
  }
}
